const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:8000';

// Access Tokenをメモリで管理（localStorageから移行）
let accessToken = null;

let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (callback) => {
    refreshSubscribers.push(callback);
};

const onRefreshed = (token) => {
    refreshSubscribers.map((callback) => callback(token));
    refreshSubscribers = [];
};

// Access Tokenのセッター（ログイン時に使用）
export const setAccessToken = (token) => {
    accessToken = token;
};

// Access Tokenのクリア（ログアウト時に使用）
export const clearAccessToken = () => {
    accessToken = null;
};

// Access Tokenの取得（デバッグ用）
export const getAccessToken = () => accessToken;

// ページロード時にCookieからトークンをリフレッシュする
export const tryRefreshToken = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
            method: 'POST',
            credentials: 'include',  // Cookieを送信
        });

        if (response.ok) {
            const data = await response.json();
            accessToken = data.access_token;
            console.log('Token refreshed successfully on page load');
            return true;
        }
        return false;
    } catch (error) {
        console.log('No valid refresh token available');
        return false;
    }
};

const api = {
    fetch: async (endpoint, options = {}) => {
        const headers = {
            ...options.headers,
        };

        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        try {
            let response = await fetch(`${API_BASE_URL}${endpoint}`, {
                ...options,
                headers,
                credentials: 'include',  // Cookie送信を有効化
            });

            if (response.status === 401 && !endpoint.startsWith('/auth/login') && !endpoint.startsWith('/auth/refresh') && !endpoint.startsWith('/auth/register') && !endpoint.startsWith('/admin/auth/login')) {
                // Refresh Tokenは自動的にCookieで送信される
                if (!isRefreshing) {
                    // ==========================================
                    // パターンA: リフレッシュ実行係（最初の人）
                    // ==========================================
                    isRefreshing = true;
                    console.log('Attempting to refresh token...');

                    try {
                        const refreshResponse = await fetch(`${API_BASE_URL}/auth/refresh`, {
                            method: 'POST',
                            credentials: 'include',  // Cookieを送信
                        });

                        if (refreshResponse.ok) {
                            const data = await refreshResponse.json();
                            const newToken = data.access_token;
                            accessToken = newToken;  // メモリに保存

                            isRefreshing = false;

                            // 1. 待機している他の人たちを起こす
                            onRefreshed(newToken);

                            // 2. ★重要★ 自分自身は「待機」せず、すぐに再実行してその結果を返す
                            headers['Authorization'] = `Bearer ${newToken}`;
                            return fetch(`${API_BASE_URL}${endpoint}`, {
                                ...options,
                                headers,
                                credentials: 'include',
                            });
                        } else {
                            throw new Error('Refresh failed');
                        }
                    } catch (error) {
                        isRefreshing = false;
                        accessToken = null;
                        window.location.href = '/login';
                        return null;
                    }
                } else {
                    // ==========================================
                    // パターンB: 待機係（リフレッシュ中に来た後続の人）
                    // ==========================================
                    // isRefreshingがtrueの間は、ここに来て待機列に並ぶ
                    return new Promise((resolve) => {
                        subscribeTokenRefresh((newToken) => {
                            headers['Authorization'] = `Bearer ${newToken}`;
                            resolve(fetch(`${API_BASE_URL}${endpoint}`, {
                                ...options,
                                headers,
                                credentials: 'include',
                            }));
                        });
                    });
                }
            }

            return response;
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }
};

export default api;
